<template>
    <div>
        <div class="card-header pr-3 pb-2 pl-3 pt-0">
            <div class="row justify-content-between align-items-center mb-0 pb-0 pb-1">
                <div class="col-12 col-lg-4">
                    <SearchComponent v-model="filters.search" />
                </div>
                <div class="col-12 col-lg-6 mt-3 mt-md-0 text-right">
                    <b-button v-if="teatro.tipo == 1 || (teatro.tipo == 2 && !footer.ocultar_pack)"
                              :to="{ name: 'back.packs-events.index' }"
                              class="mr-0 mr-md-2 mb-2 packs-eventos"
                    >
                        Packs de eventos
                    </b-button>
                    <b-button
                        :to="{ name: 'back.events.crear' }"
                        class="crearEvento mb-2"
                        v-if="permisos['eventos.crear']"
                    >
                        CREAR EVENTO
                    </b-button>
                </div>
            </div>
        </div>
        <div class="card-body" v-if="!loading">
            <template v-for="(event, index) in events.data">
                <div :key="index">
                    <div class="row mb-2" :data-cy="'evento-row-' + event.id">
                        <div class="co-12 col-md-6">
                            <div class="mb-2">
                                <strong>{{ event.codigo }}</strong> -
                                <span v-if="event.status == 1" class="mr-2">
                                    <i class="text-green fas fa-check-circle"></i>
                                </span>
                                <span v-if="event.status == 0" class="mr-2">
                                    <i class="text-warning fas fa-pause-circle"></i>
                                </span>
                                <span v-if="event.tiene_recinto" class="mr-2">
                                    <i class="fas fa-map-marker-alt"></i>
                                </span>
                                <span v-if="event.evo_match_id && teatro.evo_enabled" class="badge badge-info mr-2" title="Partido vinculado a AvanzaEsp">
                                    AvanzaEsp
                                </span>
                                - {{ event.nombre_completo }}
                            </div>
                        </div>
                        <div class="col-12 col-md-6 text-right">
                            <div class="botones-acciones">
                                <button v-if="(permisos['eventos.editar'] || permisos['eventos.crear']) && !event.compartido" class="btn btn-secondary ml-2" v-on:click.prevent="showModalCambiarImagen(event)">
                                    Cambiar imagen
                                </button>
                                <router-link
                                    :to="{
                                        name: 'back.events.compania',
                                        params: { evento_id: event.id },
                                    }"
                                    class="btn btn-primary ml-2"
                                    id="compania"
                                    v-if="permisos['eventos.editar'] && !event.compartido"
                                >
                                    <i class="fas fa-users"></i> Compañia
                                </router-link>
                                <router-link
                                    :to="{
                                        name: 'back.events.informe',
                                        params: { id: event.id },
                                    }"
                                    class="btn btn-primary ml-2"
                                    v-if="permisos['eventos.informe']"
                                >
                                    <i class="fas fa-chart-bar"></i> Informe
                                </router-link>
                                <button
                                    type="button"
                                    name="button"
                                    class="btn btn-primary ml-2"
                                    :data-cy="'sesiones-evento-' + event.id"
                                    v-if="!event.compartido"
                                    @click="expandir(index)"
                                >
                                    <i class="far fa-calendar-alt"></i> Sesiones ({{ event.numero_sesiones }})
                                </button>

                                <OpcionesDropdownComponent
                                    v-if="(permisos['eventos.editar'] || permisos['eventos.control_accesos']) && !event.compartido"
                                    :data-cy="'evento-opciones-' + event.id"
                                    v-bind:options="[
                                        ...(permisos['taquilleros.gestion'] & !permisos['eventos.editar']
                                            ? [
                                                {
                                                    to: {
                                                        name: 'back.events.fields',
                                                        params: { evento_id: event.id },
                                                    },
                                                    label: 'Campos personalizados',
                                                },
                                            ]
                                            : []),
                                        ...(permisos['eventos.editar'] && permisos['taquilleros.gestion']
                                            ? [
                                                {
                                                    to: {
                                                        name: 'back.events.editar',
                                                        params: { evento_id: event.id },
                                                    },
                                                    label: 'Editar',
                                                },
                                                ...(teatro.invitaciones_para_abonados
                                                    ? [
                                                        {
                                                            to: {
                                                                name: 'back.events.invitaciones-abonados',
                                                                params: { evento_id: event.id },
                                                            },
                                                            label: 'Invitaciones abonados',
                                                        },
                                                    ] : []),
                                                {
                                                    to: {
                                                        name: 'back.events.fields',
                                                        params: { evento_id: event.id },
                                                    },
                                                    label: 'Campos personalizados',
                                                },
                                                ...(event.preventa_configurada
                                                    ? [
                                                        {
                                                            to: {
                                                                name: 'back.events.preventa.index',
                                                                params: { evento_id: event.id },
                                                            },
                                                            label: 'Solicitudes preventa',
                                                        },
                                                    ] : []),
                                                {
                                                    to: {
                                                        name: 'back.events.puertas.index',
                                                        params: { evento_id: event.id },
                                                    },
                                                    label: 'Puertas',
                                                },
                                                {
                                                    to: {
                                                        name: 'back.events.descuentos.index',
                                                        params: { evento_id: event.id },
                                                    },
                                                    label: 'Descuentos',
                                                },
                                                {
                                                    type: 'action',
                                                    action: () => showModal('borrar-' + event.id),
                                                    label: 'Borrar',
                                                },
                                            ]
                                            : []),
                                    ]"
                                    class="botones-acciones"
                                />
                            </div>
                        </div>
                    </div>
                    <DeleteEventModal :evento="event" v-on:close="closeModal"/>
                </div>
                <div :key="'2-' + index" v-show="expand.indexOf(index) >= 0">
                    <div class="row mb-5">
                        <div class="col-12 pdng-right">
                            <hr />
                            <button class="float-right btn btn-primary" :data-cy="'crear-sesion-evento-' + event.id" @click.prevent="showCrearSesion(event)" v-if="permisos['eventos.crear']">
                                Crear sesion
                            </button>
                        </div>
                        <div class="col-12 mt-3">
                            <div>
                                <template v-for="(sesion, index) in event.sesiones">
                                    <div :key="index" class="row color-gray" :data-cy="'sesion-row-' + sesion.id">
                                        <div class="col-12 col-md-2 mb-2">
                                            <span
                                                v-if="sesion.fecha_provisional == 1"
                                                class="mr-2"
                                            >
                                                <i class="text-danger fas fa-question-circle"></i>
                                            </span>
                                            {{ sesion.fecha }}
                                        </div>
                                        <div class="col-12 col-md-10 text-right">
                                            <div class="botones-acciones">
                                                <button class="btn btn-secondary ml-2 " @click="getUrlEvent(event, sesion)">
                                                    <i class="fas fa-copy"></i> Copiar url
                                                </button>
                                                <button v-if="permisos['eventos.vender'] && !isTaquilleroVisitante" :data-cy="'test-venta-evento-' + event.id + '-sesion-' + sesion.id" class="btn btn-secondary ml-2 mb-2" @click.prevent="openTestTab(event, sesion)">
                                                    <i class="fas fa-vial"></i>Test venta
                                                </button>
                                                <router-link
                                                    :to="{
                                                        name: 'back.events.sesion.bloquear-asientos',
                                                        params: { evento_id: event.id, sesion_id: sesion.id },
                                                    }"
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-if="permisos['eventos.editar']"
                                                >
                                                    <i class="fas fa-lock"></i> Gestor butacas
                                                </router-link>
                                                <router-link
                                                    :to="{
                                                        name: 'back.events.venta',
                                                        params: { evento_id: event.id, sesion_id: sesion.id },
                                                    }"
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-if="permisos['eventos.vender']"
                                                >
                                                    <i class="fas fa-euro-sign"></i> Venta
                                                </router-link>
                                                <router-link
                                                    :to="{
                                                        name: 'back.events.ventas',
                                                        params: { evento_id: event.id, sesion_id: sesion.id },
                                                    }"
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-if="permisos['eventos.informe']"
                                                >
                                                    <i class="fas fa-ticket-alt"></i> Listado ventas
                                                </router-link>
                                                <router-link
                                                    :to="{
                                                        name: 'back.events.sesion.configuracion',
                                                        params: { evento_id: event.id, sesion_id: sesion.id },
                                                    }"
                                                    :data-cy="'precios-evento-' + event.id + '-sesion-' + sesion.id"
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-if="permisos['eventos.crear'] || permisos['eventos.editar']"
                                                >
                                                    <i class="fas fa-cogs"></i> Precios
                                                </router-link>
                                                <button
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-on:click="$modal.show('descargar-plano-pdf')"
                                                    v-if="permisos['eventos.editar']"
                                                >
                                                    <i class="fas fa-file-pdf"></i> Descargar plano pdf
                                                </button>
                                                <DescargarPlanoPdf name="descargar-plano-pdf" :evento="event" :sesion_id="sesion.id" v-on:close="$modal.hide('descargar-plano-pdf')" />
                                                <router-link
                                                    :to="{
                                                        name: 'back.events.sesion.informe.control-acceso',
                                                        params: { evento_id: event.id, sesion_id: sesion.id },
                                                    }"
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-if="permisos['eventos.informe'] && !isTaquilleroVisitante"
                                                >
                                                    INFORME CONTROL DE ACCESOS
                                                </router-link>
                                                <router-link
                                                    :to="{
                                                        name: 'back.events.sesion.control-acceso',
                                                        params: { evento_id: event.id, sesion_id: sesion.id, codigo_evento: event.codigo },
                                                    }"
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-if="permisos['eventos.control_accesos'] && !isTaquilleroVisitante"
                                                >
                                                    CONTROL DE ACCESO
                                                </router-link>
                                                <router-link
                                                    :to="{
                                                        name: 'back.events.sesion.productos',
                                                        params: { evento_id: event.id, sesion_id: sesion.id },
                                                    }"
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-if="permisos['eventos.editar']"
                                                >
                                                    Productos
                                                </router-link>
                                                <router-link
                                                    :to="{
                                                        name: 'back.events.sesion.codigos-qr',
                                                        params: { evento_id: event.id, sesion_id: sesion.id },
                                                    }"
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-if="permisos['eventos.editar']"
                                                >
                                                    Códigos QR
                                                </router-link>
                                                <router-link
                                                    :to="{
                                                        name: 'back.events.sesion.compradores-permitidos',
                                                        params: { evento_id: event.id, sesion_id: sesion.id },
                                                    }"
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-if="permisos['eventos.editar'] && event.compra_privada"
                                                >
                                                    Compradores permitidos
                                                </router-link>
                                                <DescargarInformeControlAcceso name="descargar-informe-control" :evento="event" :sesion_id="sesion.id" :taquillero_id="null" v-on:close="$modal.hide('descargar-informe-control')" />
                                                <button
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-on:click.prevent="showModalEditarSesion(sesion, event)"
                                                    v-if="permisos['eventos.editar']"
                                                >
                                                    <i class="fas fa-edit"></i> Editar
                                                </button>
                                                <button
                                                    class="btn btn-secondary ml-2 mb-2"
                                                    v-on:click.prevent="showModalBorrarSesion(sesion, event)"
                                                    v-if="permisos['eventos.editar']"
                                                >
                                                    <i class="fas fa-trash"></i> Borrar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <CrearSesionModal v-if="active_event" :evento="active_event" v-on:close="closeModal"/>
            <EditarSesionModal v-if="active_sesion" :sesion="active_sesion" :evento="active_event" v-on:close="closeModal"/>
            <DeleteSesionModal v-if="active_sesion" :sesion="active_sesion" :evento="active_event" v-on:close="closeModal"/>
            <TestVentaInfoModal v-if="active_event && active_sesion" :evento="active_event" :sesion="active_sesion" @close="closeModal" />
            <CambiarImagenModal
                v-if="active_event"
                :evento="active_event"
                @close="closeModal"
                @updated="getEvents(filters)"
            />
            <hr />
            <div class="row justify-content-between">
                <div class="col-12 col-lg-3">
                    <ElementosPorPaginaComponent v-model="filters.per_page"/>
                </div>
                <div class="col-12 col-lg-4" v-if="events">
                    <PaginateComponent
                        :current_page="events.meta.current_page"
                        :last_page="events.meta.last_page"
                        v-on:change_page="setPage"
                    />
                </div>
            </div>
        </div>
        <div class="card-body" v-else>
            <LoaderComponent/>
        </div>
    </div>
</template>

<script setup>
    import { ref, reactive, computed, watch, onMounted, nextTick, getCurrentInstance, onUnmounted } from 'vue';
    import { debounce } from 'lodash';
    import { useGetEvents } from '@/composables/admin/events/useGetEvents';
    import store from '@/store';

    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';
    import DeleteEventModal from '@/views/backend/events/modals/DeleteEventModal';
    import DeleteSesionModal from '@/views/backend/events/modals/DeleteSesionModal';
    import CrearSesionModal from '@/views/backend/events/modals/CrearSesionModal';
    import EditarSesionModal from '@/views/backend/events/modals/EditarSesionModal';
    import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent';
    import SearchComponent from '@/components/backend/components/SearchComponent';
    import ElementosPorPaginaComponent from '@/components/backend/components/ElementosPorPaginaComponent';
    import CambiarImagenModal from '@/modules/admin/eventos/modals/CambiarImagenModal.vue';
    import DescargarInformeControlAcceso from '@/views/backend/events/modals/DescargarInformeControlAcceso';
    import DescargarPlanoPdf from '@/views/backend/events/modals/DescargarPlanoPdf.vue';
    import TestVentaInfoModal from '@/views/backend/events/modals/TestVentaInfoModal.vue';

    const instance = getCurrentInstance();
    const $modal = instance.proxy.$modal;
    const $toast = instance.proxy.$toast;

    const { events, loading, getEvents } = useGetEvents();

    const expand = ref([]);
    const active_event = ref(null);
    const active_sesion = ref(null);

    const filters = reactive({
        per_page: 10,
        page: 1,
        search: '',
        e: 'actuales'
    });

    const teatro = computed(() => store.getters.getTeatro);
    const permisos = computed(() => store.getters.getPermisos);
    const footer = computed(() => store.getters.getFooter);
    const isTaquilleroVisitante = computed(() => store.getters.getUser.role === 11);

    function expandir(index) {
        const idx = expand.value.indexOf(index);
        if (idx >= 0) {
            expand.value.splice(idx, 1);
        } else {
            expand.value.push(index);
        }
    }

    function setPage(page) {
        filters.page = page;
        getEvents(filters);
    }

    function showModal(modal) {
        expand.value = [];
        $modal.show(modal);
    }

    function closeModal(modal, borrado) {
        active_sesion.value = null;
        active_event.value = null;
        $modal.hide(modal);
        if (borrado) {
            getEvents(filters);
        }
    }


    async function getUrlEvent(event, sesion) {
        let url = '';
        if (event.slug) {
            url = process.env.VUE_APP_CLE_FRONT + 'event/' + event.slug;
        } else {
            url = footer.value.url_gracias + 'eventos/' + event.id + '/' + sesion.id;
        }

        await navigator.clipboard.writeText(url);
        $toast.success('Url copiada!');
    }

    function openTestTab(event, sesion) {
        active_event.value = event;
        active_sesion.value = sesion;
        nextTick(() => {
            $modal.show('test-venta-warning-' + event.id + '-' + sesion.id);
        });
    }

    function showModalEditarSesion(sesion, evento) {
        active_sesion.value = sesion;
        active_event.value = evento;
        nextTick(() => {
            $modal.show('editar-sesion-' + sesion.id);
        });
    }

    function showModalBorrarSesion(sesion, evento) {
        active_sesion.value = sesion;
        active_event.value = evento;
        nextTick(() => {
            $modal.show('borrar-sesion-' + sesion.id);
        });
    }

    function showCrearSesion(event) {
        active_event.value = event;
        nextTick(() => {
            $modal.show('crear-sesion');
        });
    }

    function showModalCambiarImagen(evento) {
        active_event.value = evento;
        nextTick(() => {
            $modal.show('cambiar-imagen-' + evento.id);
        });
    }

    const debouncedGetEvents = debounce(() => {
        getEvents(filters);
    }, 500);

    watch(() => filters.search, debouncedGetEvents);
    watch(() => filters.per_page, debouncedGetEvents);

    onMounted(() => {
        getEvents(filters);
    });

    onUnmounted(() => {
        debouncedGetEvents.cancel();
    })
</script>

<style scoped>
    .btn {
        margin: 1% auto;
    }

    .color-gray {
        background-color: #F0F0F0;
        padding: 2% 4%;
        border-radius: 8px;
        border: 2px solid white;
        margin-bottom: 4px;
    }

    .pdng-right {
        padding-right: 4%;
    }
    .botones-acciones {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
}

.botones-acciones .btn,
.botones-acciones .dropdown {
    margin: 0 !important;
}

@media (max-width: 768px) {
    .botones-acciones {
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        text-align: center;
    }

    .botones-acciones .btn,
    .botones-acciones .dropdown {
        width: 100%;
    }
}
    @media (max-width: 768px) {
        .float-right {
            float: left !important;
            margin-left: 4px;
        }

        .crearEvento {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .ml-2 {
            margin: 5px;
            float: left;
        }

        .packs-eventos {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    @media only screen and (min-width: 768px) {
        .margin-right-20 {
            margin-right: 20px !important;
        }
    }
</style>

